export const ClarityEvent = {
  AUTOCOMPLETE_STREET_SELECTED: 'autocomplete_street_selected',
} as const;
export type ClarityEvent = (typeof ClarityEvent)[keyof typeof ClarityEvent];

/**
 * Sends a custom event to Microsoft Clarity, where it can be turned into a
 * Smart Event and used to filter session recordings.
 * @param name the event name, as it appears in the Clarity dashboard
 */
export const trackClarityEvent = (name: ClarityEvent) => {
  // Clarity is injected by GTM, so it is absent until the script has loaded —
  // and stays absent when the visitor declines tracking consent.
  if (typeof window === 'undefined' || typeof window.clarity !== 'function') {
    return;
  }

  window.clarity('event', name);
};
